import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import axios from 'axios';
import { useNavigate } from 'react-router';
// import { uploadImage } from '../../Config/azure-storage-blob.ts';
import { ServerPath } from '../../Constant/index.jsx';
import { _axios } from '../../utils/axios';
import ImageUpload from './ImageUpload';
import {uploadImage} from '../../Services/r2-storage-blob.js';


const AddTrip = () => {
    const [show, setShow] = useState(false);
    const [tripName, setTripName] = useState('');
    const [email, setEmail] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [contactName, setContactName] = useState('');
    const [thumbnail, setThumbnail] = useState('');
    const [wallpaperImages, setWallpaperImages] = useState([]);
    const [parikramaImages, setParikramaImages] = useState([]);
    const [location, setLocation] = useState('');
    const [tripLength, setTripLength] = useState('');
    const [routeType, setRouteType] = useState('');
    const [tripPath, setTripPath] = useState('');
    const [description, setDescription] = useState('');
    const [elevationGain, setElevationGain] = useState('');
    const [thumbnailName, setThumbnailName] = useState('');
    const [uploading, setUploading] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const navigate = useNavigate();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFileChange = (e) => {
        setThumbnail(e.target.files[0]);
        setThumbnailName(e.target.files[0].name);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        // Validate image uploads
        const failedUploads = [...wallpaperImages, ...parikramaImages]
            .filter(img => img.error || img.uploading);
        
        if (failedUploads.length > 0) {
            alert('Please resolve failed uploads before submitting');
            return;
        }

        setUploading(true);

        try {
            // Upload thumbnail
            const uploadedUrl = await uploadImage(thumbnail, thumbnail.name, 'parikrama-qa', 'images');
            setImageUrl(uploadedUrl);

            // Extract successfully uploaded URLs
            const wallpaperUrls = wallpaperImages
                .filter(img => img.url)
                .map(img => img.url)
                .join(',');
            
            const parikramaUrls = parikramaImages
                .filter(img => img.url)
                .map(img => img.url)
                .join(',');

            const newTrip = {
                trip_name: tripName,
                email: email,
                contact_number: contactNumber,
                contact_name: contactName,
                thumbnail: uploadedUrl,
                wallpapers: wallpaperUrls,
                parikrama_in_action: parikramaUrls,
                location: location,
                trip_length: tripLength,
                route_type: routeType,
                trip_path: tripPath,
                description: description,
                elevation_gain: elevationGain,
                status: 1,
            };

            const response = await _axios.post(`${ServerPath}/tripdetails/create`, newTrip);
            handleClose();
            window.location.reload();
        } catch (error) {
            console.error(error);
            alert('Form submission failed. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <>
            <Button onClick={handleShow} className='btn btn-primary float-end'>Create Trip</Button>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create Trip</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <Form onSubmit={handleSubmit} className="needs-validation" noValidate>
                        <Row className="g-3">
                            {/* Existing fields */}
                            <Col md={6}>
                                <Form.Group controlId="validationCustom01">
                                    <Form.Label>Trip Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tripName}
                                        onChange={(e) => setTripName(e.target.value)}
                                        placeholder="Enter Trip Name"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom02">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Enter Email"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom03">
                                    <Form.Label>Contact Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={contactName}
                                        onChange={(e) => setContactName(e.target.value)}
                                        placeholder="Enter Contact Name"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom04">
                                    <Form.Label>Contact Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={contactNumber}
                                        onChange={(e) => setContactNumber(e.target.value)}
                                        placeholder="Enter Contact Number"
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="exampleFormControlTextarea4">
                                    <Form.Label>Upload Thumbnail Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={handleFileChange}
                                        accept="image/*"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom06">
                                    <Form.Label>Length</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tripLength}
                                        onChange={(e) => setTripLength(e.target.value)}
                                        placeholder="Enter Length"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom05">
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        placeholder="Enter Location"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom07">
                                    <Form.Label>Route Type</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={routeType}
                                        onChange={(e) => setRouteType(e.target.value)}
                                        required
                                    >
                                        <option value="" disabled>Select...</option>
                                        <option value="Loop">Loop</option>
                                        <option value="Out & Back">Out & Back</option>
                                        <option value="Point to Point">Point to Point</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>

                            {/* Image Upload Sections - Side by Side */}
                            <Col md={12}><hr /></Col>
                            <Col md={6}>
                                <ImageUpload
                                    label="Wallpapers (Photo Tour)"
                                    images={wallpaperImages}
                                    setImages={setWallpaperImages}
                                    maxImages={10}
                                />
                            </Col>

                            <Col md={6}>
                                <ImageUpload
                                    label="Parikrama in Action"
                                    images={parikramaImages}
                                    setImages={setParikramaImages}
                                    maxImages={10}
                                />
                            </Col>
                            <Col md={12}><hr /></Col>

                            <Col md={12}>
                                <Form.Group controlId="exampleFormControlTextarea4">
                                    <Form.Label>Path</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={tripPath}
                                        onChange={(e) => setTripPath(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group controlId="exampleFormControlTextarea5">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        {uploading ? 'Uploading...' : 'Submit'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddTrip;